import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";
import * as rwData from "../../utils/rwData.js";

const Statefield = observer((props) => {
  //========================================================================
  // Wert aus globalVars auslesen
  let value = rwData.readRcvValue(props.props.variable);

  // falls kein Wert vorhanden, dann 0 setzen
  if (value.value === "") {
    value.value = "0";
  }

  // Index als Wert aus globalVars
  let idx = Math.abs(parseInt(value.value));

  //========================================================================
  // Simulation
  let simulation = false;
  let simValue = 0;

  try {
    simulation = props.style.properties.simulation;
    simValue = props.style.properties.simValue;
  } catch (error) {
    simulation = false;
  }

  if (simulation) {
    idx = Math.abs(parseInt(simValue));
  }

  //========================================================================
  // Text anzeigen
  // falls kein Wert vorhanden, dann 0 setzen
  if (isNaN(idx)) {
    idx = 0;
  }

  let states = ["", "", ""];
  let displayValue = ["", "", ""];

  try {
    if (props.props.states && props.props.states.length > 0) {
      states = props.props.states;
    }

    if (isFinite(idx)) {
      if (idx < props.props.states.length) {
        displayValue = states[idx];
      }
    }
  } catch (error) {}

  //========================================================================
  // Grafische Darstellung
  return (
    <div
      style={{
        ...props.style,
        visibility: props.props.visibility,
        cursor: "pointer",
      }}
      title={
        language.displayText(value.name) +
        (globalVars.cyclicUpdate || globalVars.editor
          ? "\n" + ("Variable: " + props.props.variable)
          : "")
      }
    >
      <output
        style={{
          top: "0px",
          left: "0px",
          width: "100%",
          height: "100%",
          display: "flex",
          paddingLeft: "3%",
          overflow: "hidden",
          whiteSpace: "nowrap",
          boxSizing: "border-box",
          maxWidth: `calc(${props.element.width} - 5%)`,
          justifyContent: props.element.textHorizontalAlignment,
          alignItems: props.element.textVerticalAlignment,
        }}
      >
        {language.displayText(displayValue)}
      </output>
    </div>
  );
});

export default Statefield;
